/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IObrienIdContainerViewProps } from './obrien-id-container';




export const ObrienIdContainerView: React.FC<IObrienIdContainerViewProps> = props => {

    const { 
        simpleRowcategories,
        simpleRowList,
        simpleRowListItem,
        obrienId,
        obrienClass
    
    } = props;

    
    
    return (
       
            <>
            {simpleRowcategories ? (
            <div className={obrienClass} id={obrienId}>
                <Module {...simpleRowList}>
                    { simpleRowcategories.map((simpleRowcategory: ReactNode, index: number) => {
                        return (
                        
                            <Node {...simpleRowListItem} key={index}>
                                {simpleRowcategory}
                            </Node>
                        
                        );
                    })}
                </Module>
            </div>
            ) : null}
            </>
            
    );
};

export default ObrienIdContainerView;
